import { gql } from '@apollo/client';

export const RELEASE_MCP_MUTATION = gql`
  mutation ReleaseMcp($id: Int!) {
    mcp {
      releaseMcp(id: $id) {
        success
        message {
          code
          message
        }
        content {
          id
          status
        }
      }
    }
  }
`;
